import AddressModal, { AddressModalProps } from './AddressModal';

export type { AddressModalProps };
export default AddressModal;
